webpackJsonp([4],{

/***/ 0:
/*!**********************************!*\
  !*** ./src/pages/index/index.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(/*! ../../assets/lib/boostrap/css/bootstrap.css */ 5);
	
	__webpack_require__(/*! ../../assets/lib/fontawesome/css/font-awesome.min.css */ 6);
	
	__webpack_require__(/*! ../../assets/css/main.less */ 7);
	
	__webpack_require__(/*! ./index.less */ 38);
	
	__webpack_require__(/*! ../../assets/lib/boostrap/js/bootstrap */ 4);
	
	var _main = __webpack_require__(/*! ../../assets/js/main */ 3);
	
	var _main2 = _interopRequireDefault(_main);
	
	__webpack_require__(/*! ../../assets/lib/pagination/jquery.twbsPagination */ 19);
	
	__webpack_require__(/*! ../../assets/js/animate */ 28);
	
	var _util = __webpack_require__(/*! ../../assets/js/util */ 2);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _bootbox = __webpack_require__(/*! ../../assets/lib/bootbox/bootbox */ 9);
	
	var _bootbox2 = _interopRequireDefault(_bootbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contractStatusArray = ['', '服务中', '服务中', '服务中', '已发送', '服务中', '延期完成', '服务中'];
	//弹窗
	
	//分页
	/**
	 * Created by Jason on 2017-3-6.
	 */
	
	var Month = new Date().getMonth() + 1;
	
	function Banner(id, options) {
	    var self = this;
	    var $el = self.$el = $(id).eq(0);
	    var $items = self.$items = $el.children();
	    var len = self.len = $items.length;
	    var index = self.index = 0;
	    var $label = ['<span class="banner-labels">'];
	    var i = 0;
	    var $prev, $next;
	    self.width = $el.outerWidth();
	    if (len < 2) {
	        return;
	    }
	    //label
	    for (; i < len; i++) {
	        $label.push('<i data-i="' + i + '"></i>');
	    }
	    $label.push('</span>');
	    $el.append($label.join(''));
	    self.$labels = $el.find('.banner-labels');
	    self.$abelItems = self.$labels.children();
	    self.$abelItems.eq(0).addClass('checked');
	    self.$labels.on('click', function (e) {
	        var $t = $(e.target);
	        var i = $t.data('i');
	        if (self.isScroll) {
	            return;
	        }
	        switch (i) {
	            case 'prev':
	                self._scroll(self.index - 1);
	                break;
	            case 'next':
	                self._scroll(self.index + 1);
	                break;
	            case undefined:
	            case null:
	                break;
	            default:
	                self._scroll(i);
	        }
	    });
	    //是否自动滚动
	    if (options.isAuto) {
	        //是否暂停
	        $el.on('mouseout', function () {
	            self._auto();
	        });
	        $el.on('mouseover', function () {
	            clearInterval(self.interval);
	        });
	        self._auto();
	    }
	    //上一页下一页
	    if (options.isDir) {
	        $prev = $('<span>').addClass('label-prev').data('i', 'prev').html('◀');
	        $next = $('<span>').addClass('label-next').data('i', 'next').html('▶');
	        self.$labels.prepend($prev);
	        self.$labels.append($next);
	    }
	    self.options = options;
	}
	
	Banner.prototype = {
	    construct: Banner,
	    _auto: function _auto() {
	        var self = this;
	        self.interval = setInterval(function () {
	            self._scroll(self.index + 1, true);
	        }, 4000);
	    },
	    _scroll: function _scroll(i, isAuto) {
	        var self = this;
	        var index;
	        var $scrollIn;
	        var $scrollOut, $labelIn, $labelOut;
	        var options = self.options;
	        var width = self.width;
	        i = parseInt(i);
	        if (i < 0) {
	            if (!options.isLoop) {
	                return;
	            }
	            index = self.len - 1;
	        } else if (i >= self.len) {
	            if (!options.isLoop) {
	                return;
	            }
	            index = 0;
	        } else {
	            index = i;
	        }
	        if (index === self.index) {
	            return;
	        }
	        $scrollIn = self.$items.eq(index);
	        $scrollOut = self.$items.eq(self.index);
	        $labelIn = self.$abelItems.eq(index);
	        $labelOut = self.$abelItems.eq(self.index);
	        self.isScroll = true;
	        if (index > self.index || isAuto) {
	            $scrollIn.css('left', width);
	            animate({
	                time: 400,
	                curve: 'sineInOut'
	            }, function (r) {
	                $scrollIn.css('left', width - width * r);
	                $scrollOut.css('left', -width * r);
	                self.isScroll = false;
	            });
	        } else {
	            $scrollIn.css('left', -width);
	            animate({
	                time: 400,
	                curve: 'sineInOut'
	            }, function (r) {
	                $scrollIn.css('left', -width + width * r);
	                $scrollOut.css('left', width * r);
	                self.isScroll = false;
	            });
	        }
	        $labelIn.addClass('checked');
	        $labelOut.removeClass('checked');
	        self.index = index;
	    }
	};
	
	{
	    var index = {
	        queryObj: {
	            pageNumber: 1,
	            pageSize: 15
	        },
	        init: function init(userData) {
	            var _this = this;
	            _this.companyId = localStorage.getItem('account.companyId');
	            _this.$banner = $("#banner");
	            _this.emptyHtml = '<p style="text-align: center">\u5F53\u524D\u6CA1\u6709\u901A\u77E5</p>';
	            _this.$noticeList = $("#notice-list");
	            _this.$wrap = $(".task-container .waterfall");
	            _this.userData = userData;
	            _this.getNoticeList();
	            _this.getBannerList();
	            _this.getIndexInfo();
	            _this.$wrap.on('click', function (e) {
	                var target = $(e.target);
	                var type = target.data('type');
	                var orderId = void 0,
	                    timeList = void 0;
	                switch (type) {
	                    case 'more':
	                        orderId = target.data('orderId');
	                        _this.showMore(orderId);
	                        break;
	                    case 'detail':
	                        timeList = target.data('timeList');
	                        _this.showDetail(timeList);
	                        break;
	                }
	            });
	        },
	        renderTaskName: function renderTaskName(taskName, subTask) {
	            if (subTask) {
	                return taskName + '-' + subTask;
	            } else {
	                return taskName;
	            }
	        },
	        showMore: function showMore(orderId) {
	            var _this = this;
	            var $box = void 0;
	            $.get(("https://api.custom.orancrab.com") + '/index/getOrderMorePlan', { companyId: _this.companyId, orderId: orderId }, function (json) {
	                if (json.status == 0) {
	                    var messageHtml = '<table class="table table-bordered">\n                                     <thead>\n                                        <tr>\n                                          <th>\u9884\u8BA1\u5B8C\u6210\u65F6\u95F4</th>\n                                          <th>\u5B9E\u9645\u5B8C\u6210\u65F6\u95F4</th>\n                                          <th>\u4EFB\u52A1</th>\n                                          <th>\u72B6\u6001</th>\n                                        </tr>\n                                      </thead>\n                                      <tbody>';
	                    json.data.forEach(function (item) {
	                        messageHtml += '<tr>\n                                        <td>' + (item.estimateFullfilTime ? _util2.default.getYearMonthDaySimple(item.estimateFullfilTime) : "") + '</td>\n                                        <td>' + (item.auditSendTime ? _util2.default.getYearMonthDaySimple(item.auditSendTime) : "") + '</td>\n                                        <td>' + _this.renderTaskName(item.taskName, item.subTask) + '</td>\n                                        <td>' + (item.taskStatus && contractStatusArray[item.taskStatus]) + '</td>\n                                      </tr>';
	                    });
	
	                    messageHtml += '</tbody>\n                                    </table>';
	                    $box = _bootbox2.default.dialog({
	                        title: '任务列表',
	                        message: messageHtml,
	                        buttons: {
	                            '关闭': function _(e) {
	                                console.log('提交');
	                            }
	                        },
	                        show: false
	                    });
	                }
	                $box.modal('show');
	            });
	        },
	        showDetail: function showDetail(timeList) {
	            var $box = void 0;
	            var messageHtml = '<table class="table table-bordered">\n                                     <thead>\n                                        <!--<tr>-->\n                                          <!--<th>\u4FEE\u6539\u6B21\u6570</th>-->\n                                          <!--<th>\u9884\u8BA1\u65F6\u95F4</th>-->\n                                      <!---->\n                                        <!--</tr>-->\n                                      </thead>\n                                      <tbody>';
	            timeList.forEach(function (item) {
	                messageHtml += '<tr>\n                                        <td>' + item[0] + '</td>\n                                        <td>' + (item[1] ? _util2.default.getYearMonthDaySimple(item[1]) : "") + '</td>\n                                      </tr>';
	            });
	            messageHtml += '</tbody>\n                                    </table>';
	            $box = _bootbox2.default.dialog({
	                title: '预计时间修改列表',
	                message: messageHtml,
	                buttons: {
	                    '关闭': function _(e) {
	                        console.log('提交');
	                    }
	                },
	                show: false
	            });
	            $box.modal('show');
	        },
	        getIndexInfo: function getIndexInfo() {
	            var _this = this;
	            $.get(("https://api.custom.orancrab.com") + '/index/getCompanyIndexInfo', { companyId: _this.companyId, sourceType: 1 }, function (json) {
	                if (json.status == 0 && json.data.length > 0) {
	                    _this.renderIndexInfo(json.data);
	                } else {
	                    var html = '<div style=" color: #e3e3e3;text-align: center; flex-direction:column;display: flex;justify-content: center"><p style="font-size: 100px;" class="fa fa-sticky-note-o fa-6" aria-hidden="true"></p><p style="">\u6682\u65E0\u670D\u52A1\u4E2D\u7684\u8BA2\u5355</p></div>';
	                    $(".task-container").html(html);
	                }
	            });
	        },
	        renderIndexInfo: function renderIndexInfo(data) {
	            var _this2 = this;
	
	            var html = '';
	            data.forEach(function (item) {
	                html += '<div class="pin clearfix">\n                      <p class="time__line-header">' + item.orderName + ' ' + (item.isShowMore ? '(' + Month + '\u6708)' : "") + '<span class="pull-right server-time">\u670D\u52A1\u65F6\u957F\uFF1A' + item.serveDuration + ' \u4E2A\u6708</span>\n                        </p>\n                        <ul class="time__line">';
	                html += _this2.renderCompanyIndexTaskVoList(item.companyIndexTaskVoList);
	                if (item.isShowMore) {
	                    html += '</ul>\n                            <button class="btn btn-primary btn-xs pull-right" type="button" data-type="more" data-order-id="' + item.orderId + '">\u67E5\u770B\u66F4\u591A</button>\n                    </div>';
	                } else {
	                    html += '</ul></div>';
	                }
	            });
	            this.$wrap.html(html);
	        },
	        renderCompanyIndexTaskVoList: function renderCompanyIndexTaskVoList(companyIndexTaskVoList) {
	            var _this = this;
	            var dom = '<li class="row line-header time__line-item">\n                                <div class="col-md-3">\u9884\u8BA1\u5B8C\u6210\u65F6\u95F4</div>\n                                <!--<div class="time__line-item-tail ready"></div>-->\n                                <div class="col-md-3">\u5B9E\u9645\u5B8C\u6210\u65F6\u95F4</div>\n                                <div class="col-md-4">\u4EFB\u52A1</div>\n                                <div class="col-md-2">\u72B6\u6001</div>\n                            </li>';
	            for (var i = 0; i < companyIndexTaskVoList.length; i++) {
	                if (companyIndexTaskVoList[i].taskStatus == 4) {
	                    dom += '<li class="row time__line-item ready">\n                        <div class="col-md-3">' + (companyIndexTaskVoList[i].estimateFullfilTime ? _util2.default.getYearMonthDaySimple(companyIndexTaskVoList[i].estimateFullfilTime) : "") + ' </div>';
	                    if (i < companyIndexTaskVoList.length - 1) {
	                        dom += '<div class="time__line-item-tail"></div>';
	                    }
	
	                    dom += '<div class="time__line-item-head "></div>\n                        <div class="col-md-3"> ' + (companyIndexTaskVoList[i].auditSendTime ? _util2.default.getYearMonthDaySimple(companyIndexTaskVoList[i].auditSendTime) : "") + ' </div>\n                        <div class="col-md-4">' + _this.renderTaskName(companyIndexTaskVoList[i].taskName, companyIndexTaskVoList[i].subTask) + '</div>\n                        <span class="col-md-2">' + contractStatusArray[companyIndexTaskVoList[i].taskStatus] + '</span>\n                        </li>';
	                } else {
	                    dom += '<li class="row time__line-item ready">\n                        <div class="col-md-3">' + (companyIndexTaskVoList[i].estimateFullfilTime ? _util2.default.getYearMonthDaySimple(companyIndexTaskVoList[i].estimateFullfilTime) : "") + ' </div>';
	                    if (i < companyIndexTaskVoList.length - 1) {
	                        dom += '<div class="time__line-item-tail"></div>';
	                    }
	                    dom += '<div class="time__line-item-head "></div>\n                        <div class="col-md-3"> ' + (companyIndexTaskVoList[i].auditSendTime ? _util2.default.getYearMonthDaySimple(companyIndexTaskVoList[i].auditSendTime) : "") + ' </div>\n                        <div class="col-md-4">' + _this.renderTaskName(companyIndexTaskVoList[i].taskName, companyIndexTaskVoList[i].subTask) + '</div>';
	                    if (companyIndexTaskVoList[i].eftNum > 1) {
	                        dom += '<a class="col-md-2 time-detail" data-type="detail" data-time-list=' + JSON.stringify(companyIndexTaskVoList[i].estimateFullfilTimeList) + '>\u9884\u8BA1\u65F6\u95F4\u5DF2\u4FEE\u6539</a>';
	                    } else {
	                        dom += '<span class="col-md-2">' + contractStatusArray[companyIndexTaskVoList[i].taskStatus] + '</span>';
	                    }
	                }
	                dom += '</li>';
	            }
	            return dom;
	        },
	        getBannerList: function getBannerList() {
	            var _this = this;
	            $.get(("https://api.custom.orancrab.com") + '/banner/getBannerList', _this.queryObj, function (json) {
	                if (json.status == 0) {
	                    var html = '';
	                    if (json.data.length > 0) {
	                        json.data.forEach(function (item) {
	                            html += '<a target="view_window" href="' + (item.bannerGotoUrl ? item.bannerGotoUrl : '#') + '"><div style="width: 100%;height: 100%;background:  url(' + ('' + (("https://api.custom.orancrab.com") + '/upload/image/' + item.photoUrl)) + ') no-repeat left;"></div></a>';
	                        });
	                        _this.$banner.html(html);
	                    } else {
	                        _this.$banner.html('     <a target="view_window" href="http://www.51chengxie.com/index" >\n                    <div style="width: 100%;height:100%;background:url(\'../../assets/img/banner.png\') no-repeat center"> </div>\n                </a>');
	                    }
	
	                    setTimeout(function () {
	                        //初始化banner
	                        new Banner('#banner', {
	                            isAuto: true,
	                            isLoop: true,
	                            isDir: false
	                        });
	                    }, 0);
	                }
	            });
	        },
	        getNoticeList: function getNoticeList() {
	            var _this = this;
	            $.get(("https://api.custom.orancrab.com") + '/notice/queryNoticePage', _this.queryObj, function (json) {
	                if (json.status == 0) {
	                    var curPage = _this.$noticeList.data("cpage") ? _this.$noticeList.data("cpage") : 1;
	                    var pageCount = json.data.pages;
	                    var noticeList = json.data.content;
	                    _this.createOrderPage(pageCount, curPage, _this.$noticeList);
	                    if (noticeList.length > 0) {
	                        _this.renderNoticeList(noticeList, _this.$noticeList);
	                    } else {
	                        _this.$noticeList.html(_this.emptyHtml);
	                    }
	                }
	            });
	        },
	        renderNoticeList: function renderNoticeList(noticeList, parentNode) {
	            var _this = this;
	            parentNode.empty();
	            noticeList.forEach(function (element, index, array) {
	                parentNode.append(_this.getNoticeItem(element));
	            });
	        },
	        getNoticeItem: function getNoticeItem(element) {
	            var html = '<li class="notice-item">\n                <a href="/notice-detail.html?noticeId=' + element.noticeId + '" >\n                <div class="notice-header clearfix">\n                <span class="notice-title pull-left">' + element.title + '</span>\n                <span class="notice-time pull-right">' + _util2.default.formatDate(element.createTime) + '</span>\n                </div>\n                </a></li>';
	            return html;
	        },
	
	        //创建分页
	        createOrderPage: function createOrderPage(pageCount, curPage, parentNode) {
	            //默认5页
	            var _this = this;
	            var visiblePages = 10,
	                pageContainer = $('.page-area'),
	                cPage = curPage;
	            if (pageCount < visiblePages) {
	                visiblePages = pageCount;
	            }
	
	            if (pageCount <= 0) {
	                pageContainer.html('');
	                return;
	            }
	            pageContainer.find('ul').empty();
	            pageContainer.html('<ul class="pagination"></ul>');
	            //解绑原来的分页
	            if (pageContainer.find('ul').data("twbs-pagination")) {
	                cPage = 1;
	                pageContainer.twbsPagination('destroy');
	            }
	            //创建分页
	            pageContainer.find('ul').twbsPagination({
	                totalPages: pageCount,
	                visiblePages: visiblePages,
	                first: '首页',
	                prev: '上一页',
	                next: '下一页',
	                last: '尾页',
	                startPage: cPage,
	                initiateStartPageClick: false,
	                onPageClick: function onPageClick(event, page) {
	                    $(parentNode).data("cpage", page);
	                    _this.queryObj.number = page;
	                    _this.getNoticeList();
	                }
	            });
	        }
	    };
	    _main2.default.ready(function (userData) {
	        index.init(userData);
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 1)))

/***/ }),

/***/ 28:
/*!**********************************!*\
  !*** ./src/assets/js/animate.js ***!
  \**********************************/
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * 创建: 王伟
	 * 邮箱：wangw@wondershare.cn
	 * 时间: 2015/2/7 16:01
	 * 描述:
	 * 贝塞尔曲线请访问 http://cubic-bezier.com/ 进行调试
	 * 查看
	 */
	(function (win) {
	    var requestAnimationFrame = win.requestAnimationFrame || win.webkitRequestAnimationFrame || function (callback) {
	        win.setTimeout(callback, 1000 / 60);
	    },
	        cancelAnimationFrame = win.cancelRequestAnimationFrame || win.webkitCancelRequestAnimationFrame || win.clearTimeout,
	        timeout,
	        now = win.Date.now,
	        stack = {},
	        id = 0,
	        size = 0,
	        curves_obj = {},
	
	    /**
	     *  options 一下属性
	     *  time 毫秒,必选
	     *  loop 循环类型 "once", "loop", "once_back", "loop_back"，可选，默认一次
	     *  curve，曲线，可选，默认linear，支持bezier数组[[x1, y1], [x2, y2]]
	     * @param callback
	     * @returns {number}
	     */
	    animate = win.animate = function (options, callback) {
	        var time = options.time,
	            loop = options.loop || "once",
	            curve = options.curve;
	        if (!time) {
	            throw new win.RangeError("时间设置错误");
	        }
	        switch (typeof curve === "undefined" ? "undefined" : _typeof(curve)) {
	            case "string":
	                curve = curves_obj[curve];
	                break;
	            case "object":
	                curve = bezier(curve);
	                break;
	            default:
	                curve = undefined;
	        }
	        size++;
	        stack[++id] = {
	            "time": time,
	            "easing": curve,
	            "callback": callback,
	            "stamp": now(),
	            "loop": loop,
	            "percent": 0,
	            "pause": false
	        };
	
	        if (size === 1) {
	            timeout = requestAnimationFrame(run);
	        }
	        return id;
	    };
	
	    /**
	     * 暂停
	     * @param id
	     */
	    animate.pause = function (id) {
	        var p, item;
	        if (id === undefined) {
	            cancelAnimationFrame(timeout);
	            for (p in stack) {
	                stack[p].pause = true;
	            }
	            size = 0;
	        } else {
	            item = stack[id];
	            if (item && item.pause === false) {
	                item.pause = true;
	                size--;
	                if (size === 0) {
	                    cancelAnimationFrame(timeout);
	                }
	            }
	        }
	        return animate;
	    };
	    /**
	     * 恢复pause的动画
	     * @param id
	     */
	    animate.run = function (id) {
	        var p,
	            item,
	            i = 0;
	        if (id === undefined) {
	            for (p in stack) {
	                stack[p].pause = false;
	                i++;
	            }
	            if (!size && i) {
	                timeout = requestAnimationFrame(run);
	            }
	            size = i;
	        } else {
	            item = stack[id];
	            if (item && item.pause === true) {
	                item.pause = false;
	                size++;
	                if (size === 1) {
	                    timeout = requestAnimationFrame(run);
	                }
	            }
	        }
	        return animate;
	    };
	    /**
	     * 停止
	     * @param id
	     */
	    animate.stop = function (id) {
	        var item = stack[id];
	        if (item) {
	            item.callback(item.percent, -1);
	            delete stack[id];
	            size--;
	            if (!size) {
	                cancelAnimationFrame(timeout);
	            }
	        }
	        return animate;
	    };
	    /**
	     * 全部停止
	     */
	    animate.stop_all = function () {
	        var p, item;
	        cancelAnimationFrame(timeout);
	        for (p in stack) {
	            item = stack[p];
	            item.callback(item.percent, -1);
	        }
	        stack = {};
	        size = 0;
	        return animate;
	    };
	    /**
	     * 运行
	     */
	    function run() {
	        var p,
	            item,
	            now_stamp = now(),
	            timing,
	            time,
	            ratio,
	            easing;
	        for (p in stack) {
	            item = stack[p];
	            if (item.pause) {
	                continue;
	            }
	            timing = now_stamp - item.stamp;
	            time = item.time;
	            easing = item.easing;
	            switch (item.loop) {
	                case "once":
	                    ratio = timing / time;
	                    if (ratio >= 1) {
	                        item.callback(1, 1);
	                        delete stack[p];
	                        size--;
	                    } else {
	                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
	                    }
	                    break;
	                case "loop":
	                    ratio = timing / time;
	                    if (ratio >= 1) {
	                        //下一次循环开始
	                        item.callback(1, 0);
	                        item.percent = 1;
	                        item.stamp = now_stamp;
	                    } else {
	                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
	                    }
	                    break;
	                case "once_back":
	                    ratio = timing * 2 / time;
	                    if (timing >= time) {
	                        item.callback(0, 1);
	                        delete stack[p];
	                        size--;
	                    } else if (ratio >= 1) {
	                        item.callback(item.percent = easing ? easing(2 - ratio) : 2 - ratio, 0);
	                    } else {
	                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
	                    }
	                    break;
	                case "loop_back":
	                    ratio = timing * 2 / time;
	                    if (timing >= time) {
	                        //下一次循环开始
	                        item.callback(0, 0);
	                        item.stamp = now_stamp;
	                        item.percent = 0;
	                    } else if (ratio >= 1) {
	                        item.callback(item.percent = easing ? easing(2 - ratio) : 2 - ratio, 0);
	                    } else {
	                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
	                    }
	            }
	        }
	        if (size) {
	            timeout = requestAnimationFrame(run);
	        }
	    }
	
	    /**
	     * 贝塞尔曲线
	     * @param coordinate
	     * @returns {Function}
	     */
	    function bezier(coordinate) {
	        var t = 0,
	            x1 = coordinate[0],
	            x2 = coordinate[2],
	            y1 = coordinate[1],
	            y2 = coordinate[3];
	        if (x1 > 1 || x1 < 0 || x2 > 1 || x1 < 0) {
	            alert("x坐标必须在0-1之间！");
	        }
	        return function (x) {
	            t = bisection(x, t, x1, x2);
	            var t2 = t * t,
	                at = 1 - t;
	            return 3 * y1 * t * at * at + 3 * y2 * t2 * at + t2 * t;
	        };
	    }
	
	    /**
	     * 二分法
	     * @param x
	     * @param pev_t
	     * @param x1
	     * @param x2
	     * @returns {*}
	     */
	    function bisection(x, pev_t, x1, x2) {
	        if (x === 0 || x === 1) {
	            return x;
	        }
	        var i,
	            middle,
	            t0 = Math.max(0, pev_t - .2),
	            t1 = Math.min(1, pev_t + .2),
	            t,
	            t2,
	            at;
	        for (i = 0; i < 20; i++) {
	            t = (t0 + t1) / 2;
	            t2 = t * t;
	            at = 1 - t;
	            middle = 3 * x1 * t * at * at + 3 * x2 * t2 * at + t2 * t;
	            if (middle > x) {
	                if (middle - x < 1e-6) {
	                    break;
	                }
	                t1 = t;
	            } else if (middle < x) {
	                if (x - middle < 1e-6) {
	                    break;
	                }
	                t0 = t;
	            } else {
	                break;
	            }
	        }
	        return t;
	    }
	
	    /**
	     * 动画曲线
	     */
	    (function () {
	        var Math = win.Math,
	            pi2 = Math.PI * 2;
	        curves_obj = animate.curves_obj = {
	            linear: function linear(t) {
	                return t;
	            },
	
	            quadIn: getPowIn(2),
	            quadOut: getPowOut(2),
	            quadInOut: getPowInOut(2),
	
	            cubicIn: getPowIn(3),
	            cubicOut: getPowOut(3),
	            cubicInOut: getPowInOut(3),
	
	            quartIn: getPowIn(4),
	            quartOut: getPowOut(4),
	            quartInOut: getPowInOut(4),
	
	            quintIn: getPowIn(5),
	            quintOut: getPowOut(10),
	            quintInOut: getPowInOut(5),
	
	            sineIn: function sineIn(t) {
	                return 1 - Math.cos(t * Math.PI / 2);
	            },
	            sineOut: function sineOut(t) {
	                return Math.sin(t * Math.PI / 2);
	            },
	            sineInOut: function sineInOut(t) {
	                return -0.5 * (Math.cos(Math.PI * t) - 1);
	            },
	
	            expoIn: function expoIn(t) {
	                return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
	            },
	
	            expoOut: function expoOut(t) {
	                return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
	            },
	
	            expoInOut: function expoInOut(t) {
	                if (t === 0 || t === 1) {
	                    return t;
	                }
	                if ((t /= 0.5) < 1) {
	                    return 0.5 * Math.pow(2, 10 * (t - 1));
	                }
	                return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	            },
	
	            backIn: getBackIn(1.7),
	            backOut: getBackOut(1.7),
	            backInOut: getBackInOut(1.7),
	
	            circIn: function circIn(t) {
	                return -(Math.sqrt(1 - t * t) - 1);
	            },
	            circOut: function circOut(t) {
	                return Math.sqrt(1 - --t * t);
	            },
	            circInOut: function circInOut(t) {
	                if ((t *= 2) < 1) {
	                    return -0.5 * (Math.sqrt(1 - t * t) - 1);
	                }
	                return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	            },
	
	            bounceIn: function bounceIn(t) {
	                return 1 - curves_obj.bounceOut(1 - t);
	            },
	            bounceOut: function bounceOut(t) {
	                if (t < 1 / 2.75) {
	                    return 7.5625 * t * t;
	                }
	                if (t < 2 / 2.75) {
	                    return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
	                }
	                if (t < 2.5 / 2.75) {
	                    return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
	                }
	                return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
	            },
	            bounceInOut: function bounceInOut(t) {
	                if (t < 0.5) {
	                    return curves_obj.bounceIn(t * 2) * .5;
	                }
	                return curves_obj.bounceOut(t * 2 - 1) * 0.5 + 0.5;
	            },
	
	            elasticIn: getElasticIn(1, 0.3),
	            elasticOut: getElasticOut(1, 0.3),
	            elasticInOut: getElasticInOut(1, 0.3 * 1.5),
	
	            swingFromTo: function swingFromTo(pos) {
	                var s = 1.70158;
	                return (pos /= 0.5) < 1 ? 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s)) : 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
	            },
	            swingFrom: function swingFrom(pos) {
	                var s = 1.70158;
	                return pos * pos * ((s + 1) * pos - s);
	            },
	            swingTo: function swingTo(pos) {
	                var s = 1.70158;
	                return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
	            },
	
	            blink: function blink(t) {
	                return Math.round(t * 5) % 2;
	            },
	            spring: function spring(pos) {
	                return 1 - Math.cos(pos * 4.5 * Math.PI) * Math.exp(-pos * 6);
	            }
	        };
	
	        function getPowIn(pow) {
	            return function (t) {
	                return Math.pow(t, pow);
	            };
	        }
	
	        function getPowOut(pow) {
	            return function (t) {
	                return 1 - Math.pow(1 - t, pow);
	            };
	        }
	
	        function getPowInOut(pow) {
	            return function (t) {
	                if ((t *= 2) < 1) {
	                    return 0.5 * Math.pow(t, pow);
	                }
	                return 1 - 0.5 * Math.abs(Math.pow(2 - t, pow));
	            };
	        }
	
	        function getBackIn(amount) {
	            return function (t) {
	                return t * t * ((amount + 1) * t - amount);
	            };
	        }
	
	        function getBackOut(amount) {
	            return function (t) {
	                return --t * t * ((amount + 1) * t + amount) + 1;
	            };
	        }
	
	        function getBackInOut(amount) {
	            amount *= 1.525;
	            return function (t) {
	                if ((t *= 2) < 1) return 0.5 * (t * t * ((amount + 1) * t - amount));
	                return 0.5 * ((t -= 2) * t * ((amount + 1) * t + amount) + 2);
	            };
	        }
	
	        function getElasticIn(amplitude, period) {
	            return function (t) {
	                if (t == 0 || t == 1) {
	                    return t;
	                }
	                var s = period / pi2 * Math.asin(1 / amplitude);
	                return -(amplitude * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * pi2 / period));
	            };
	        }
	
	        function getElasticOut(amplitude, period) {
	            return function (t) {
	                if (t == 0 || t == 1) {
	                    return t;
	                }
	                var s = period / pi2 * Math.asin(1 / amplitude);
	                return amplitude * Math.pow(2, -10 * t) * Math.sin((t - s) * pi2 / period) + 1;
	            };
	        }
	
	        function getElasticInOut(amplitude, period) {
	            return function (t) {
	                var s = period / pi2 * Math.asin(1 / amplitude);
	                if ((t *= 2) < 1) {
	                    return -0.5 * (amplitude * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * pi2 / period));
	                }
	                return amplitude * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * pi2 / period) * 0.5 + 1;
	            };
	        }
	    })();
	})(window);

/***/ }),

/***/ 38:
/*!************************************!*\
  !*** ./src/pages/index/index.less ***!
  \************************************/
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/index.js